/* eslint-disable eqeqeq */
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import Grid from "@mui/material/Grid";
import WmsHead from "./processComponent/WmsHead";
import WmsContent from "./processComponent/WmsContent";
import "./PendingDoDetailReport.css";
import { CmpButton } from "../../Component/Common/ToolBox/ToolBox";
// fExecuteAPI
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";

import {
  ReportTitle,
  ReportRemoveSequenceChar,
  ReportUrl,
} from "../../Utility/Utilitys";

import {
  HeadObjectInit,
  sWebPendingDoDetailReportData,
  sWebBetweenReportArr,
  GetWMSMISAttributes,
  GetWmsStockRepotParty,
  fValidationHead_Client,
  fValidationDetail_Client,
  sWebStampedReportArr,
  sWebStampedDetailReportArr,
} from "./PendingDoDetailReportAction";

import * as React from "react";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";

export default function PendingDoDetailReport() {
  const vMediaQuery = useMediaQuery("(max-width:450px)");

  //Head
  const [HeadObject, setHeadObject] = useState(HeadObjectInit);

  const sBufferObjInit = {
    sDetailReportRadioBtnName: "PENDING_FOR_DELIVERY",
    sStamped: sWebStampedReportArr[0].Uid,
    sStampedDetail: sWebStampedDetailReportArr[0].Uid,
  };

  const [sBufferObj, setBufferObj] = useState(sBufferObjInit);

  const [sLocationData, setLocationData] = useState([
    // { Uid: "Distribution", Value: "Distribution" },
  ]);

  const [sLoadingBayData, setLoadingBayData] = useState([]);

  const [sTransactionData, setTransactionData] = useState([]);
  const [sSalesGroupData, setSalesGroupData] = useState([]);
  const [sTruckData, setTruckData] = useState([]);
  const [sDriverData, setDriverData] = useState([]);
  const [sStatusData, setStatusData] = useState([]);

  const [sDocTypeData, setDocTypeData] = useState([]);

  const [sPartyData, setPartyData] = useState([]);
  const [sClusterData, setClusterData] = useState([]);

  //Detail
  const DetailReportRadioBtn = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      sDetailReportRadioBtnName: e.target.value,
      sStamped: sWebStampedReportArr[0].Uid,
      sStampedDetail: sWebStampedDetailReportArr[0].Uid,
    }));
  };

  const fStamped = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      sStamped: e.target.value,
    }));
  };
  const fStampedDetail = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      sStampedDetail: e.target.value,
    }));
  };
  //Head

  const fDocType = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sDocType: e.target.value,
      sDocTypeArr: [],
      sDocTypePrnt: "",
      sDocTypeName: "",
    }));
  };
  const fDocType_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sDocTypeArr: value,
      sDocTypePrnt: value?.length <= 0 ? "" : currentPrnt,
      sDocTypeName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fDate = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sDate: e.target.value,
      sFromDate: new Date(),
      sToDate: new Date(),
    }));
  };
  const fFromDate = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setHeadObject((obj) => ({
        ...obj,
        sFromDate: "",
      }));
    } else {
      setHeadObject((obj) => ({
        ...obj,
        sFromDate: e?.$d,
      }));
    }
  };
  const fToDate = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setHeadObject((obj) => ({
        ...obj,
        sToDate: "",
      }));
    } else {
      setHeadObject((obj) => ({
        ...obj,
        sToDate: e?.$d,
      }));
    }
  };
  const fDocNo_Input = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sDocNo_Input: e.target.value,
    }));
  };

  const fDocNo = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sDocNo: e.target.value,
      sDocNo_Input: "",
    }));
  };
  const fLoadingBay = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sLoadingBay: e.target.value,
      sLoadingBayrArr: [],
      sLoadingBayrPrnt: "",
      sLoadingBayrName: "",
    }));
  };
  const fLoadingBay_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sLoadingBayArr: value,
      sLoadingBayPrnt: value?.length <= 0 ? "" : currentPrnt,
      sLoadingBayName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fTransaction = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sTransaction: e.target.value,
      sTransactionArr: [],
      sTransactionPrnt: "",
      sTransactionName: "",
    }));
  };
  const fTransaction_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sTransactionArr: value,
      sTransactionPrnt: value?.length <= 0 ? "" : currentPrnt,
      sTransactionName: value?.length <= 0 ? "" : currentName,
    }));
  };
  const fSalesGroup_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sSalesGroupArr: value,
      sSalesGroupPrnt: value?.length <= 0 ? "" : currentPrnt,
      sSalesGroupName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fTruck = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sTruck: e.target.value,
      sTruckArr: [],
      sTruckPrnt: "",
      sTruckName: "",
    }));
  };
  const fTruck_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sTruckArr: value,
      sTruckPrnt: value?.length <= 0 ? "" : currentPrnt,
      sTruckName: value?.length <= 0 ? "" : currentName,
    }));
  };
  const fDriver = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sDriver: e.target.value,
      sDriverArr: [],
      sDriverPrnt: "",
      sDriverName: "",
    }));
  };
  const fStatus = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sStatus: e.target.value,
    }));
  };
  const fDriver_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sDriverArr: value,
      sDriverPrnt: value?.length <= 0 ? "" : currentPrnt,
      sDriverName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fLocation = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sLocation: e.target.value,
      sLocationArr: [],
      sLocationPrnt: "",
      sLocationName: "",
      sLoadingBay: "All",
      sLoadingBayCode: "",
      sLoadingBayPrnt: "",
      sLoadingBayName: "",
    }));
  };

  const fLocation_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sLocationArr: value,
      sLocationPrnt: value?.length <= 0 ? "" : currentPrnt,
      sLocationName: value?.length <= 0 ? "" : currentName,
    }));
    if (value?.length <= 0) {
      fLocation_Focus();
    }
  };
  const fLocation_Focus = (value) => {
    setHeadObject((obj) => ({
      ...obj,
      sLoadingBay: "All",
      sLoadingBayArr: [],
      sLoadingBayPrnt: "",
      sLoadingBayName: "",
    }));
  };

  //common_PartyListReport_GETROW
  const fParty = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sPartyArr: [],
      sPartyPrnt: "",
      sPartyName: "",
    }));
    if (e.target.value.toUpperCase() == "ALL") {
      setPartyData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      await GetWmsStockRepotParty(setPartyData);
    }
  };
  const fParty_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sPartyArr: value,
      sPartyPrnt: value?.length <= 0 ? "" : currentPrnt,
      sPartyName: value?.length <= 0 ? "" : currentName,
    }));
  };

  //common_ClusterListReport_GETROW
  const fCluster = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sClusterArr: [],
      sClusterPrnt: "",
      sClusterName: "",
    }));
  };
  const fCluster_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sClusterArr: value,
      sClusterPrnt: value?.length <= 0 ? "" : currentPrnt,
      sClusterName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fCancel = (e) => {
    setHeadObject(HeadObjectInit);
    setBufferObj(sBufferObjInit);
    // setPartyData([]);
    // setClusterData([]);
  };

  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);

  const GetReportsView = async () => {
    let xType = sBufferObj.sDetailReportRadioBtnName;

    let urlPrint = vRdxDBKernObj.WEB_REPORT_BASE_URL?.Val;
    let sCurrentReport = "";
    let sReportTitle = "";

    if (
      sBufferObj.sDetailReportRadioBtnName?.toUpperCase() === "STAMP_PENDING"
    ) {
      xType = sBufferObj.sStamped;
    }
    if (
      sBufferObj.sDetailReportRadioBtnName?.toUpperCase() ===
      "STAMP_DTL_PENDING"
    ) {
      xType = sBufferObj.sStampedDetail;
    }
    let ReportTitleObj = {
      DocTyp: HeadObject.sDocTypeName,
      DateBetween:
        "Between " +
        moment(HeadObject.sFromDate).format("DD-MM-YYYY") +
        " and " +
        moment(HeadObject.sToDate).format("DD-MM-YYYY"),
      DocNo: HeadObject.sDocNo_Input,
      Cluster: HeadObject.sClusterName,
      party: HeadObject.sPartyName,
      Location: HeadObject.sLocationName,
      LoadingBay: HeadObject.sLoadingBayName,
      Transaction: HeadObject.sTransactionName,
      SalesGroup: HeadObject.sSalesGroupName,
      Truck: HeadObject.sTruckName,
      Driver: HeadObject.sDriverName,
      Status: HeadObject.sStatus,
    };

    // Remove the trailing "&" character
    sReportTitle = ReportTitle(ReportTitleObj);
    // ?VocTyp1=%20&VocDt1=01/01/1900&VocDt2=01/01/2900&VocNo=%20&Cluster=%20&Party=%20&Loc=%20&LDPAY=%20&Trans=%20&Truck=%20&ReportType=PENDING_FOR_DELIVERY&Status=All

    let ReportUrlObj = {
      ReportType: xType,
      VocTyp1: HeadObject.sDocTypePrnt,
      VocDt1: moment(HeadObject.sFromDate).format("MM-DD-YYYY"),
      VocDt2: moment(HeadObject.sToDate).format("MM-DD-YYYY"),
      VocNo: HeadObject.sDocNo_Input,
      Cluster: HeadObject.sClusterPrnt,
      Party: HeadObject.sPartyPrnt,
      Loc: HeadObject.sLocationPrnt,
      LDPAY: HeadObject.sLoadingBayPrnt,
      Trans: HeadObject.sTransactionPrnt,
      SalesGrp: HeadObject.sSalesGroupPrnt,
      // Truck: HeadObject.sTruckPrnt,
      Truck: HeadObject.sDriverPrnt,
      Status: HeadObject.sStatus,

      // reportTitle: sReportTitle,
    };
    console.log(ReportUrlObj);
    sCurrentReport = ReportUrl(ReportUrlObj);

    sCurrentReport = ReportRemoveSequenceChar(sCurrentReport);

    // console.log("ReportUrlObj", ReportUrlObj);
    // console.log("sCurrentReport", sCurrentReport);
    console.log(
      "sCurrentReport",
      urlPrint + "WMS/PendingDoDetail001?" + sCurrentReport
    );
    setWebReportUrlModal(urlPrint + "WMS/PendingDoDetail001?" + sCurrentReport);
    fWebReport();
  };

  const fPreview = async (e) => {
    let iValidationHead_Client = fValidationHead_Client(HeadObject);
    if (!iValidationHead_Client) return;
    let iValidationDetail_Client = fValidationDetail_Client(
      sBufferObj,
      HeadObject
    );
    if (!iValidationDetail_Client) return;
    await GetReportsView();
  };

  //Modal Summary
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  //Modal fWebReportModal
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };

  const fLoad = async () => {
    await GetWMSMISAttributes(
      setLoadingBayData,
      setTransactionData,
      setTruckData,
      setDriverData,
      setPartyData,
      setClusterData,
      setDocTypeData,
      setLocationData,
      setStatusData,
      setSalesGroupData
    );
  };

  useEffect(() => {
    fLoad();
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={vMediaQuery ? "py-4" : "py-4"}
          >
            <Grid item xs={12} sm={12} md={8}>
              <WmsHead
                fFromDate={fFromDate}
                fToDate={fToDate}
                fDocNo_Input={fDocNo_Input}
                fDocNo={fDocNo}
                fDate={fDate}
                fLocation_MultiSelect={fLocation_MultiSelect}
                sLocationData={sLocationData}
                fParty_MultiSelect={fParty_MultiSelect}
                sPartyData={sPartyData}
                fCluster_MultiSelect={fCluster_MultiSelect}
                sClusterData={sClusterData}
                fLoadingBay_MultiSelect={fLoadingBay_MultiSelect}
                fTransaction_MultiSelect={fTransaction_MultiSelect}
                fSalesGroup_MultiSelect={fSalesGroup_MultiSelect}
                fTruck_MultiSelect={fTruck_MultiSelect}
                fDriver_MultiSelect={fDriver_MultiSelect}
                fDocType_MultiSelect={fDocType_MultiSelect}
                sWebPendingDoDetailReportData={sWebPendingDoDetailReportData}
                sWebBetweenReportArr={sWebBetweenReportArr}
                sLoadingBayData={sLoadingBayData}
                sTransactionData={sTransactionData}
                sSalesGroupData={sSalesGroupData}
                sTruckData={sTruckData}
                sDriverData={sDriverData}
                sStatusData={sStatusData}
                sDocTypeData={sDocTypeData}
                HeadObject={HeadObject}
                fLocation={fLocation}
                fParty={fParty}
                fCluster={fCluster}
                fLoadingBay={fLoadingBay}
                fTransaction={fTransaction}
                fTruck={fTruck}
                fDriver={fDriver}
                fStatus={fStatus}
                fDocType={fDocType}
              />
            </Grid>
            {/* <Grid
              item
              xs={12}
              sm={12}
              md={3}
              className={vMediaQuery ? "hide-content" : " "}
            >
              <WmsContent
                DetailReportRadioBtn={DetailReportRadioBtn}
                xtitle={"Detail Report"}
                selectedOption={sBufferObj.sDetailReportRadioBtnName}
                sBufferObj={sBufferObj}
                fStamped={fStamped}
                fStampedDetail={fStampedDetail}
                sWebStampedReportArr={sWebStampedReportArr}
                sWebStampedDetailReportArr={sWebStampedDetailReportArr}
              />
            </Grid> */}
          </Grid>
          <Grid
            container
            rowSpacing={{ xs: 1, sm: 0, md: 0 }}
            columnSpacing={{ xs: 1, sm: 0, md: 3 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              vMediaQuery
                ? " justify-content-center text-center"
                : "py-2 justify-content-center text-center"
            }
          >
            <Grid item xs={6} sm={6} md={"auto"} className="text-center">
              <CmpButton
                xbtnName="Preview"
                xOnClick={fPreview}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={"auto"} className="text-center">
              <CmpButton
                xbtnName="Cancel"
                xOnClick={fCancel}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>

            <Grid
              item
              xs={6}
              sm={6}
              md={"auto"}
              className={
                vMediaQuery ? "text-center" : "text-center hide-content"
              }
            >
              <CmpButton
                xbtnName="Detail"
                xOnClick={fSummary}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
          </Grid>
        </div>
      </div>

      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Detail Report"} onClose={fCloseSummaryModal} />
          <div className="py-3 px-2">
            <WmsContent
              DetailReportRadioBtn={DetailReportRadioBtn}
              xtitle={"Detail Report"}
              selectedOption={sBufferObj.sDetailReportRadioBtnName}
              sBufferObj={sBufferObj}
              fStamped={fStamped}
              fStampedDetail={fStampedDetail}
              sWebStampedReportArr={sWebStampedReportArr}
              sWebStampedDetailReportArr={sWebStampedDetailReportArr}
            />
          </div>
        </Box>
      </Modal>

      {/* webReport  */}

      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </div>
  );
}
